const initialState = {
    ph1: null,
    ph2: null,
    ph3: null,
    referCallNumber: null,
    isReferCall: false,
    errorMsg: null,
    numberTypes: ["Mobile", "Telephone"],
    selectedNumberType: "Mobile",
    goToNextPage: false,
    billingAddress: {
        streetName: null,
        city: null,
        state: null,
        zipCode: null
    },
    isAddressCall: false,
    suspendStartDate: null,
    suspendEndDate: null,
    minDate: new Date(),
    maxDate: null,
    isOrderSuccessSuspend: false,
    monDetailsSuspend: null,
    isSubmitBtnClickedSuspend:false,
    isOrderSuccessRestore: false,
    monDetailsRestore: null,
    isSubmitBtnClickedRestore:false,
    states: [{
        abbreviation: 'AL',
        stateName: 'Alabama'
    },
    {
        abbreviation: 'AK',
        stateName: 'Alaska'
    },
    {
        abbreviation: 'AS',
        stateName: 'American Samoa'
    },
    {
        abbreviation: 'AZ',
        stateName: 'Arizona'
    },
    {
        abbreviation: 'AR',
        stateName: 'Arkansas'
    },
    {
        abbreviation: 'CA',
        stateName: 'California'
    },
    {
        abbreviation: 'CO',
        stateName: 'Colorado'
    },
    {
        abbreviation: 'CT',
        stateName: 'Connecticut'
    },
    {
        abbreviation: 'DE',
        stateName: 'Delaware'
    },
    {
        abbreviation: 'DC',
        stateName: 'District of Columbia'
    },
    {
        abbreviation: 'FM',
        stateName: 'Federated States Of Micronesia'
    },
    {
        abbreviation: 'FL',
        stateName: 'Florida'
    },
    {
        abbreviation: 'GA',
        stateName: 'Georgia'
    },
    {
        abbreviation: 'GU',
        stateName: 'Guam'
    },
    {
        abbreviation: 'HI',
        stateName: 'Hawaii'
    },
    {
        abbreviation: 'ID',
        stateName: 'Idaho'
    },
    {
        abbreviation: 'IL',
        stateName: 'Illinois'
    },
    {
        abbreviation: 'IN',
        stateName: 'Indiana'
    },
    {
        abbreviation: 'IA',
        stateName: 'Iowa'
    },
    {
        abbreviation: 'KS',
        stateName: 'Kansas'
    },
    {
        abbreviation: 'KY',
        stateName: 'Kentucky'
    },
    {
        abbreviation: 'LA',
        stateName: 'Louisiana'
    },
    {
        abbreviation: 'ME',
        stateName: 'Maine'
    },
    {
        abbreviation: 'MH',
        stateName: 'Marshall Islands'
    },
    {
        abbreviation: 'MD',
        stateName: 'Maryland'
    },
    {
        abbreviation: 'MA',
        stateName: 'Massachusetts'
    },
    {
        abbreviation: 'MI',
        stateName: 'Michigan'
    },
    {
        abbreviation: 'MN',
        stateName: 'Minnesota'
    },
    {
        abbreviation: 'MS',
        stateName: 'Mississippi'
    },
    {
        abbreviation: 'MO',
        stateName: 'Missouri'
    },
    {
        abbreviation: 'MT',
        stateName: 'Montana'
    },
    {
        abbreviation: 'NE',
        stateName: 'Nebraska'
    },
    {
        abbreviation: 'NV',
        stateName: 'Nevada'
    },
    {
        abbreviation: 'NH',
        stateName: 'New Hampshire'
    },
    {
        abbreviation: 'NJ',
        stateName: 'New Jersey'
    },
    {
        abbreviation: 'NM',
        stateName: 'New Mexico'
    },
    {
        abbreviation: 'NY',
        stateName: 'New York'
    },
    {
        abbreviation: 'NC',
        stateName: 'North Carolina'
    },
    {
        abbreviation: 'ND',
        stateName: 'North Dakota'
    },
    {
        abbreviation: 'MP',
        stateName: 'Northern Mariana Islands'
    },
    {
        abbreviation: 'OH',
        stateName: 'Ohio'
    },
    {
        abbreviation: 'OK',
        stateName: 'Oklahoma'
    },
    {
        abbreviation: 'OR',
        stateName: 'Oregon'
    },
    {
        abbreviation: 'PW',
        stateName: 'Palau'
    },
    {
        abbreviation: 'PA',
        stateName: 'Pennsylvania'
    },
    {
        abbreviation: 'PR',
        stateName: 'Puerto Rico'
    },
    {
        abbreviation: 'RI',
        stateName: 'Rhode Island'
    },
    {
        abbreviation: 'SC',
        stateName: 'South Carolina'
    },
    {
        abbreviation: 'SD',
        stateName: 'South Dakota'
    },
    {
        abbreviation: 'TN',
        stateName: 'Tennessee'
    },
    {
        abbreviation: 'TX',
        stateName: 'Texas'
    },
    {
        abbreviation: 'UT',
        stateName: 'Utah'
    },
    {
        abbreviation: 'VT',
        stateName: 'Vermont'
    },
    {
        abbreviation: 'VI',
        stateName: 'Virgin Islands'
    },
    {
        abbreviation: 'VA',
        stateName: 'Virginia'
    },
    {
        abbreviation: 'WA',
        stateName: 'Washington'
    },
    {
        abbreviation: 'WV',
        stateName: 'West Virginia'
    },
    {
        abbreviation: 'WI',
        stateName: 'Wisconsin'
    },
    {
        abbreviation: 'WY',
        stateName: 'Wyoming'
    },
    ]
}

function vacation(state = initialState, action) {

    switch (action.type) {
        case "HANDLE_REFER_CALL":
            return {
                ...state,
                isReferCall: action.value
            }

        case `UPDATE_${action.id}`:
            return {
                ...state,
                [`${action.id}`.toLowerCase()]: action.value,

            }


        case "UPDATE_PHONE_NUMBER":
            return {
                ...state,
                referCallNumber: action.value.isValidTN && state.ph1 !== null && state.ph2 !== null && state.ph3 !== null ? state.ph1 + state.ph2 + state.ph3 : null,
                errorMsg: action.value.isValidTN ? null : action.value
            }
        case "CHANGE_NUMBER_TYPE":
            return {
                ...state,
                selectedNumberType: action.value
            }
        case "GO_TO_NEXT_PAGE":
            return {
                ...state,
                goToNextPage: action.value
            }
        case "UPDATE_BILLING_ADDRESS":
            return {
                ...state,
                billingAddress: {
                    ...state.billingAddress,
                    [action.payload.target.id]: action.payload.target.value
                }
            }
        case "HANDLE_ADDRESS_CALL":
            return {
                ...state,
                isAddressCall: action.value
            }
        case "HANDLE_SUSPEND_START_DATE":
            let daysDiffernce = new Date(new Date(state.suspendEndDate) - new Date(action.value)).getUTCDate() - 1
            let suspendEndDate = (new Date(action.value) > new Date(state.suspendEndDate)) || daysDiffernce < 30 ? null : state.suspendEndDate
            return {
                ...state,
                suspendStartDate: action.value,
                minDate: action.minDate,
                maxDate: action.maxDate,
                suspendEndDate
            }
        case "HANDLE_SUSPEND_END_DATE":
            return {
                ...state,
                suspendEndDate: action.value
            }
        case "HANDLE_SUMBIT_SUSPEND_RESPONSE":
            return {
                ...state,
                isOrderSuccessSuspend: action.value,
                monDetailsSuspend: action.monDetails,
                isSubmitBtnClickedSuspend:action.isSubmitBtnClicked
            }
        case "HANDLE_SUMBIT_RESTORE_RESPONSE":
            return {
                ...state,
                isOrderSuccessRestore: action.value,
                monDetailsRestore: action.monDetails,
                isSubmitBtnClickedRestore:action.isSubmitBtnClicked
                }
        default:
            return state
    }
}


export default vacation